export default __webpack_public_path__ + "static/media/photo-1546967191-fdfb13ed6b1e.f4b6002c.jpeg";